export default __webpack_public_path__ + "static/media/practice.d9676b4d.png";